//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

// Stale time of 5min
export const FIVE_MINUTES_STALE_TIME = 300000;

// Stale time of 20 seconds
export const TWENTY_SECONDS_STALE_TIME = 20000;
